import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';
import { Link } from 'gatsby';

const NewsCardSmall = ({ news }) => (
  <Link to="#" className={styles.news}>
    <div className={styles.news_image}>
      <img
        className={styles.news_image_inner}
        src={news.image}
        alt={news.title}
      />
    </div>
    <div className={styles.news_txt}>
      <p className={classnames('cr-lead', styles.news_txt_title)}>
        {news.title}
      </p>

      <p className={classnames('cr-sub cr-text-2', styles.news_txt_date)}>
        {news.date}
      </p>
    </div>
  </Link>
);

export default NewsCardSmall;
